/* eslint no-undef:0 */
import pageNames from "./pageNameIdentifiers";

function getPageDetails(id) {
  return pageNames[id];
}
function trackLink(options) {
  const fpti = {};
  // set link name
  fpti.link = options.link;

  // set page name
  const pageDetails = getPageDetails(options.id);
  fpti.pgrp = pageDetails.pageGroupName;
  fpti.page = pageDetails.pageName;
  fpti.pglk = `${pageDetails.pageGroupName}|${options.link}`;
  fpti.pgln = `${pageDetails.pageName}|${options.link}`;

  // clearing out error props in case they exist
  fpti.erpg = undefined;
  fpti.erfd = undefined;
  fpti.eccd = undefined;

  // setting component
  fpti.comp = "brcappnodeweb";

  PAYPAL.analytics.Analytics.prototype.recordClick({ data: fpti });
}

function trackPage(options) {
  const fpti = {};
  const pageDetails = getPageDetails(options.id);
  fpti.pgrp = pageDetails.pageGroupName;
  fpti.page = pageDetails.pageName;
  if (options.link) {
    fpti.pglk = `${pageDetails.pageGroupName}|${options.link}`;
    fpti.pgln = `${pageDetails.pageName}|${options.link}`;
  }
  // clearing out error props in case they exist
  fpti.erpg = undefined;
  fpti.erfd = undefined;
  fpti.eccd = undefined;

  // setting component
  fpti.comp = "brcappnodeweb";
  PAYPAL.analytics.Analytics.prototype.recordImpression({ data: fpti });
}

function trackError(options) {
  const fpti = {};
  // set page name
  const pageDetails = getPageDetails(options.id);
  fpti.pgrp = pageDetails.pageGroupName;
  fpti.page = pageDetails.pageName;

  if (options.errorField) {
    fpti.erpg = pageDetails.pageName;
    fpti.erfd = options.errorField;
  }

  PAYPAL.analytics.Analytics.prototype.recordImpression({ data: fpti });
}
export function getFptiEventForFormSubmit(
  country,
  locale,
  formName,
  status,
  reason,
  page,
  form,
  accountType,
  encryptedNumber,
  formSubmitted
) {
  
  const fpti = {};
  fpti.e = "fs";
  fpti.pgrp = `main:help:brc::${page}`;
  fpti.page = formSubmitted ? `${fpti.pgrp}::download-form` :`${fpti.pgrp}::form-submit`;
  fpti.link = form;
  fpti.pglk = `${fpti.pgrp}|${fpti.link}`;
  fpti.pgln = `${fpti.page}|${fpti.link}`;
  fpti.comp = "brcappnodeweb";
  fpti.ec = formSubmitted ? "Download form": "form submit";
  fpti.ea = fpti.pgln;
  fpti.el = country.toUpperCase();
  fpti.rsta = locale;
  fpti.ccpg = country;
  fpti.flnm = formSubmitted ? "download_form" : "form_submit";
  fpti.fltp = formName;
  fpti.status = status;
  fpti.reason = reason;
  if (accountType === "PERSONAL") {
    fpti.cust = encryptedNumber;
    fpti.mrid = '';
  } else if (accountType === "BUSINESS") {
    fpti.cust = '';
    fpti.mrid = encryptedNumber;
  } else {
    fpti.cust = '';
    fpti.mrid = '';
  }

  PAYPAL.analytics.instance.record({ data: fpti });
}

export { trackError, trackLink, trackPage };
